// change your configuration here
const config = {
  repoName: 'wintertraeume',
  analyticsGtm: 'GTM-P2KH2DC',
  defaultLanguage: 'de-de',
  preferredHost: 'winter.wien.info',
  redirects: []
}

module.exports = config
